
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MentorshipMasterState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allMentorshipMaster: [] | null | any;
}

const initialState: MentorshipMasterState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allMentorshipMaster: null,
};

export const mentorshipMasterSlice = createSlice({
    name: 'MentorshipMaster',
    initialState,
    reducers: {
        setAllMentorshipMaster: (state, action) => {
            state.allMentorshipMaster = action.payload.data;
        },
        setMentorshipMaster: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },
        setAllMentorshipMasterBySearch: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },
        reset: (state) => {
            state = initialState;
        },
    },
});

export const { setAllMentorshipMaster, setMentorshipMaster, setAllMentorshipMasterBySearch, reset } = mentorshipMasterSlice.actions;

export const allMentorshipMasterDetails = (state: RootState) => state.mentorshipMaster.allMentorshipMaster;
export const getAllMentorshipMasterDetails = (state: RootState) => state.mentorshipMaster.data;
export const getMentorshipMasterTotalRecords = (state: RootState) => state.mentorshipMaster.totalRecords;
export const getAllMentorshipMasterBySearch = (state: RootState) => state.mentorshipMaster.data;

export default mentorshipMasterSlice.reducer;
